// extracted by mini-css-extract-plugin
export default {"root":"SectionHeroCustom_root__eig4B"};